import _Object$assign from "babel-runtime/core-js/object/assign";
import _typeof from "babel-runtime/helpers/typeof";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

var _this2 = this;

import Vue from "vue";

import mathjs from "../../tools/mathjsLib";
Vue.prototype.$math = mathjs;

import VueRouter from "vue-router";
import { sync } from "vuex-router-sync";

import routes from "../../router/routers";
import store from "../../vuex";
import types from "../../vuex/mutation-types.js";
import axios from "axios";
import "../../mock/mock.js";
import index from "./index.vue";

import ui from "../../lib/ui.js";
Vue.use(ui);

import core from "../../../src/lib/core.js";
Vue.use(core);
import "@old/css/common.css";

require("es6-promise").polyfill();

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "animate.css/animate.min.css";

Vue.use(ElementUI);
import log from "../../tools/logSystem/log";
log.initMonitor();

import "../../styles/css/app.css";
import baseConfig from "../../config/baseConfig.js";
import axiosConfig from "../../config/axiosConfig.js";
import defineConfig from "../../config/defineConfig.js";
import sysConfig from "../../config/sysConfig.js";
import txtConfig from "../../config/txtConfig.js";
import bizConfig from "../../config/bizConfig.js";
import bizPublicMethod from "../../business/businessTools/bizPublicMethod.js";
import "view-design/dist/styles/iview.css";
import ViewUI from "view-design";

import commonService from "@/service/common-service";
Vue.prototype.$commonService = commonService;

Vue.use(ViewUI);
Vue.use(baseConfig);
Vue.use(axiosConfig);
Vue.use(defineConfig);
Vue.use(sysConfig);
Vue.use(txtConfig);
Vue.use(bizConfig);

import storage from "../../tools/storage.js";
Vue.use(types);
Vue.use(storage);
Vue.use(bizPublicMethod);

Vue.prototype.$http = axios;

Vue.config.errorHandler = log.errorHandleVue;

var originPush = VueRouter.prototype.push;
var originReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve || reject) {
    return originPush.call(this, location, resolve, reject);
  } else {
    return originPush.call(this, location).catch(function (err) {});
  }
};
VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject);
  } else {
    originReplace.call(this, location, function () {}, function () {});
  }
};

Vue.use(VueRouter);
var router = new VueRouter({
  routes: routes
});

sync(store, router);

router.beforeEach(function () {
  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(to, from, next) {
    var userInfo, token, authList, allowFlag, url, i;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            console.log("to----", to.path);
            userInfo = storage.$storage.getSession(defineConfig.$definecfg.USER_INFO);

            if (userInfo == null) {
              if (baseConfig.$basecfg.platform == "vtm" && to.path !== "/userLogin") {
                ElementUI.Message({
                  type: "warning",
                  message: "柜员信息失效，请重新绑定"
                });
                next("/userLogin");
              }
            }

            if (!(store.state.permission.editAuth === null)) {
              _context2.next = 6;
              break;
            }

            _context2.next = 6;
            return store.dispatch("getPermission");

          case 6:
            if (to.path == "/home" || to.path == "/homeCustomer") {
              consoleLog("退出登录了，返回柜员首页,上一页面是", from.path);

              next("/businessList");
            }

            if (!to.meta.requireAuth) {
              _context2.next = 23;
              break;
            }

            token = sessionStorage.getItem("TOKEN");

            if (!token) {
              _context2.next = 22;
              break;
            }

            if (!to.meta.allowAuth) {
              _context2.next = 20;
              break;
            }

            authList = to.meta.allowAuth.split(",");

            if (to.path.includes("mobile_video_witness")) {
              authList.push("witnessAuth");
            }
            allowFlag = false;

            authList.map(function (v) {
              if (!!store.state.permission[v]) {
                allowFlag = true;
                return false;
              }
            });

            if (allowFlag) {
              _context2.next = 20;
              break;
            }

            console.log("无权访问,禁止跳转");
            vm.alert("无访问权限");
            vm.confirm({
              messageText: "无访问权限!",
              cancelButtonText: "取消",
              canceledAction: function canceledAction() {
                if (from.name == "bizCheck") {
                  next("/home");
                }
              },
              confirmButtonText: "重新登录",
              confirmedAction: function () {
                var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return vm.$syscfg.K_Request("F0000003", {});

                        case 3:
                          _context.next = 8;
                          break;

                        case 5:
                          _context.prev = 5;
                          _context.t0 = _context["catch"](0);

                          consoleError("退出登录失败");

                        case 8:
                          vm.$store.commit(vm.$types.UPDATE_TOKEN, "");
                          vm.$store.commit(vm.$types.UPDATE_USER_INFO, "");
                          next("/userLogin");

                        case 11:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, this, [[0, 5]]);
                }));

                function confirmedAction() {
                  return _ref2.apply(this, arguments);
                }

                return confirmedAction;
              }()
            });

            throw "无访问权限";

          case 20:
            _context2.next = 23;
            break;

          case 22:
            next({
              path: "/userLogin"
            });

          case 23:

            if (/\/http/.test(to.path)) {
              url = to.path.split("http")[1];

              window.location.href = "http" + url;
            } else {
              next();
            }

            for (i in window.ajaxQueue) {
              window.ajaxQueue[i].cancel("cancel");
            }

            window.ajaxQueue = [];
          case 26:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this2);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());

router.afterEach(function (to) {
  if (process.env.NODE_ENV === "production") {}
});

router.hideRoute = function (param) {
  var index = router.getRouteIndex(param);
  if (index != -1) {
    router.updateRoute(index, "show", false);
  }
};

router.showRoute = function (param) {
  var index = router.getRouteIndex(param);
  if (index != -1) {
    router.updateRoute(index, "show", true);
  }
};

router.routerNameIncludeBool = function (param) {
  var routeTable = store.state.bizRouteTable;
  for (var i = 0; i < routeTable.length; i++) {
    if (routeTable[i].name == param) {
      return true;
    }
  }
  return false;
};

router.getRouteIndex = function (param) {
  var routeTable = store.state.bizRouteTable;

  if (typeof param === "string") {
    if (param.startsWith("/")) {
      var path = param.split("?")[0];
      for (var i = 0; i < routeTable.length; i++) {
        if (routeTable[i].path == path) {
          return i;
        }
      }
    } else {
      for (var _i = 0; _i < routeTable.length; _i++) {
        if (routeTable[_i].name == param || routeTable[_i]._name == param) {
          return _i;
        }
      }
    }
  } else if (typeof param === "number" && param < routeTable.length && param >= 0) {
    return param;
  }

  return -1;
};

router.getRoute = function (index) {
  if (router.getRouteIndex(index) != -1) {
    return store.state.bizRouteTable[index];
  } else {
    throw "getRoute 位置错误";
  }
};

router.getCurrentRouteIndex = function () {
  return store.state.bizRouteIndex;
};
router.getPreRouteIndex = function () {
  return store.state.preBizRouteIndex;
};

router.getCurrentRoute = function () {
  return router.getRoute(router.getCurrentRouteIndex());
};

router.addRoute = function (index, route) {
  if ((typeof route === "undefined" ? "undefined" : _typeof(route)) !== "object" || !("name" in route) || !("path" in route)) {
    throw "addRoute route结构错误";
  }

  if (router.getRouteIndex(index) != -1) {
    var routeTable = _.cloneDeep(store.state.bizRouteTable);
    if (!("show" in route)) {
      route["show"] = true;
    }

    routeTable.splice(index, 0, route);
    store.commit(types.$types.UPDATE_BIZ_ROUTE_TABLE, routeTable);
  } else {
    throw "addRoute 位置错误";
  }
};

router.deleteRoute = function (index) {
  if (router.getRouteIndex(index) != -1) {
    var routeTable = _.cloneDeep(store.state.bizRouteTable);
    routeTable.splice(index, 1);
    store.commit(types.$types.UPDATE_BIZ_ROUTE_TABLE, routeTable);
    store.commit(types.$types.UPDATE_ROUTE_TABLE_FLAG, true);
  } else {
    throw "deleteRoute 位置错误";
  }
};

router.updateRoute = function (index, key, value) {
  if (router.getRouteIndex(index) != -1) {
    if (typeof key === "string") {
      if (key !== "path") {
        var routeTable = _.cloneDeep(store.state.bizRouteTable);
        routeTable[index][key] = value;
        store.commit(types.$types.UPDATE_BIZ_ROUTE_TABLE, routeTable);
        store.commit(types.$types.UPDATE_ROUTE_TABLE_FLAG, true);
      }
    } else {
      throw "updateRoute 参数错误";
    }
  } else {
    throw "updateRoute 位置错误";
  }
};

router.goRoute = function (param) {
  var qData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var routeTable = store.state.bizRouteTable;
  var index = router.getRouteIndex(param);
  if (index < routeTable.length && index >= 0) {
    if (routeTable[index].show) {
      var rPath = routeTable[index].path;
      if ("query" in routeTable[index]) {
        _Object$assign(qData, routeTable[index].query);
      }
      router.updatePreRouteIndex(index);
      store.commit(types.$types.UPDATE_BIZ_ROUTE_INDEX, index);
      router.push({
        path: rPath,
        query: qData
      });
    } else {
      if (router.isFromPrevStep()) {
        router.goPrev();
        console.log("当前页面已隐藏，跳转上个页面");
      } else if (router.isFromNextStep()) {
        router.goNext();
        console.log("当前页面已隐藏，跳转下个页面");
      } else {
        throw "router.goRoute 当前页面已隐藏";
      }
    }
  } else {
    throw "router.goRoute 跳转错误，找不到此路径";
  }
};

router.updatePreRouteIndex = function (nextIndex) {
  var currentIndex = router.getCurrentRouteIndex();
  if (currentIndex != nextIndex && currentIndex >= 0) {
    store.commit(types.$types.UPDATE_PRE_BIZ_ROUTE_INDEX, currentIndex);
  }
};

router.isFromPrevStep = function () {
  var currentIndex = router.getCurrentRouteIndex();
  var preIndex = router.getPreRouteIndex();
  if (preIndex == null || currentIndex == null) {
    return false;
  }
  return currentIndex < preIndex;
};

router.isFromNextStep = function () {
  return !router.isFromPrevStep();
};
router.getPrevShowRouteIndex = function () {
  var routeTable = store.state.bizRouteTable;
  var routeIndex = store.state.bizRouteIndex;

  for (var i = routeIndex - 1; i >= 0; i--) {
    if (routeTable[i].show && !routeTable[i].ignorePrev) {
      return i;
    }
  }
  return -1;
};

router.getNextShowRouteIndex = function () {
  var routeTable = store.state.bizRouteTable;
  var routeIndex = store.state.bizRouteIndex;

  for (var i = routeIndex + 1; i < routeTable.length; i++) {
    if (routeTable[i].show && !routeTable[i].ignoreNext) {
      return i;
    }
  }
  return -1;
};

router.goNext = function () {
  router.goRoute(router.getNextShowRouteIndex());
};

router.goPrev = function () {
  router.goRoute(router.getPrevShowRouteIndex());
};

router.goBackCurrent = function () {
  var qData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  router.goRoute(router.getCurrentRouteIndex(), qData);
};

router.goModule = function (module) {
  var qData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _Object$assign(qData, {
    "_modulePage": true
  });
  router.push({
    name: module,
    query: qData
  });
};

Vue.config.productionTip = false;

Vue.prototype.$vtmDispatch = function (_this, componentName, eventName, params) {
  consoleLog("\u8C03\u7528\u7236\u7EC4\u4EF6" + componentName + "\u7684" + eventName + "\u51FD\u6570\uFF0C\u5165\u53C2\u4E3A", params);
  var parent = _this.$parent || _this.$root;
  var name = parent.$options.componentName;

  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;

    if (parent) {
      name = parent.$options.componentName;
    }
  }
  if (parent && parent.$options.componentName == componentName) {
    consoleLog("调用上级组件函数成功", componentName);
    return parent[eventName] && parent[eventName].apply(this, [].concat(params));
  }
}, Vue.prototype.$vtmBroadcast = function (_this, componentName, eventName, params) {
  _this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      return _this.$vtmBroadcast.broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
};

window.vm = new Vue({
  store: store,
  router: router,
  render: function render(h) {
    return h(index);
  }
}).$mount("#vtm");


//////////////////
// WEBPACK FOOTER
// ./src/html/index/index.js
// module id = 818
// module chunks = 2